import api from '@pray/shared/utils/api';

export const getAllTags = async ({
  offset = 0,
  limit = 0,
  search = '',
  sortColumn = '',
  sortDirection = 'asc',
  artistId = null,
  options = {},
} = {}) => {
  const params = {};

  if (offset) params.offset = offset;

  if (limit) params.limit = limit;

  if (search) params.search = search;

  if (sortColumn) {
    params.sort_column = sortColumn;
    params.sort_direction = sortDirection;
  }

  // When artistId is provided, return only tags used by this artist with artist-specific counts
  if (artistId) {
    params.artist_id = artistId;
  }

  const url = `/web/studio/tags`;
  const response = await api.executeGetRequest(url, params, options);

  return response.data;
};
